import { css } from 'styled-components'

export const LegendaryColor = css`
  background: linear-gradient(89.96deg, #4799cc 0.03%, #ffd600 99.83%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  text-fill-color: transparent;
`

export const EpicColor = css`
  color: ${({ theme }) => theme.colors.blue};
`

export const RareColor = css`
  color: ${({ theme }) => theme.colors.legendary};
`

export const SpecialColor = css`
  color: ${({ theme }) => theme.colors.success};
`

export const CommonColor = css`
  color: ${({ theme }) => theme.colors.text};
`
